import { ComponentProps, CSSProperties, FunctionComponent, useId } from 'react'
import cl from 'clsx'
import { QuestionSVGIcon } from '@/shared/assets'
import {
    Checkbox,
    CheckboxProps,
    // type CheckboxProps,
    // ClickTooltip
} from '@/shared/ui'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/ui/tooltip'
import { Label } from '@/shared/ui/label'
import { ReactNode } from 'react'
import { ClickTooltip } from '@/shared/ui'

import classes from './MarkingPartLayout.module.scss'
import { MARKING_DIALOG_LAYOUT } from './data'

const LAYOUT_STYLE = {
    gridTemplateColumns: `${MARKING_DIALOG_LAYOUT.whiteColumn.width}px ${
        MARKING_DIALOG_LAYOUT.blueColumn.paddingLeft +
        MARKING_DIALOG_LAYOUT.blueColumn.contentWidth
    }px`,
}

const WHITE_COLUMN_STYLE = {
    paddingRight: MARKING_DIALOG_LAYOUT.whiteColumn.paddingRight,
}

const BLUE_COLUMN_STYLE = {
    paddingLeft: MARKING_DIALOG_LAYOUT.blueColumn.paddingLeft,
    // paddingRight: LAYOUT.blueColumn.paddingRight,
}

export type MarkingPartLayoutProps = {
    flagValue?: boolean | 'error'
    checkboxDisabled?: string
    checkboxDisabledTooltipOnClick?: () => void
    checkboxOnChange?: (v: boolean) => void

    title: string
    Icon: FunctionComponent<ComponentProps<'svg'>>
    tooltipContent?: ReactNode
    children: ReactNode
    headerContent?: ReactNode
    checkboxLabel?: string

    labeledCheckboxStyle?: CSSProperties

    checkboxVariant?: CheckboxProps['variant']
}
export const MarkingPartLayout = ({
    Icon,
    flagValue = false,
    checkboxDisabled = '',
    checkboxDisabledTooltipOnClick,
    checkboxLabel,
    checkboxOnChange,

    headerContent,

    title,
    tooltipContent,
    children,
    labeledCheckboxStyle,

    checkboxVariant = 'green',
}: MarkingPartLayoutProps) => {
    const checkboxId = useId()

    const checkboxOnChangeHandler:
        | React.ChangeEventHandler<HTMLInputElement>
        | undefined = checkboxOnChange
        ? (evt) => checkboxOnChange(evt.target.checked)
        : undefined

    let checkbox = checkboxLabel ? (
        <Checkbox
            disabled={Boolean(checkboxDisabled)}
            id={checkboxId}
            checked={flagValue === true}
            onChange={checkboxOnChangeHandler}
            sizeVariant="big"
            variant={checkboxVariant}
            size={20}
        />
    ) : null

    if (checkbox && checkboxDisabled) {
        checkbox = (
            <ClickTooltip className={'flex'} enabled message={checkboxDisabled}>
                <div
                    className={'flex'}
                    onClick={checkboxDisabledTooltipOnClick}
                >
                    {checkbox}
                </div>
            </ClickTooltip>
        )
    }

    return (
        <div className={classes.layout} style={LAYOUT_STYLE}>
            <div className={classes.header} style={WHITE_COLUMN_STYLE}>
                <Icon
                    className={cl(classes.icon, {
                        [classes.checked]: flagValue === true,
                        [classes.error]: flagValue === 'error',
                    })}
                />
                <h2 className="text-sm font-semibold">{title}</h2>
                {tooltipContent && (
                    <Tooltip>
                        <TooltipTrigger>
                            <QuestionSVGIcon className="cursor-pointer" />
                        </TooltipTrigger>
                        <TooltipContent side="top">
                            {tooltipContent}
                        </TooltipContent>
                    </Tooltip>
                )}
                <div className={'grow'} />
                <div>{headerContent}</div>
            </div>

            <div />

            <div style={WHITE_COLUMN_STYLE}>{children}</div>

            <div className={classes.right} style={BLUE_COLUMN_STYLE}>
                {checkbox && (
                    <div
                        className={classes.labeledCheckbox}
                        style={labeledCheckboxStyle}
                    >
                        {checkbox}
                        <Label
                            htmlFor={checkboxId}
                            className="w-[79px] text-[10px] font-medium leading-3"
                        >
                            {checkboxLabel}
                        </Label>
                    </div>
                )}
            </div>
        </div>
    )
}
